import { useState } from "react";
import TextInput from "../../components/TextInput";
import EmailInput from "../../components/EmailInput";
import PasswordInput from "../../components/PasswordInput";
import { Link } from "react-router-dom";
import { parseJwt } from "../Dashboard/Dashboard";

const ProfilePage = () => {
  const token = localStorage.getItem("authToken");
  const user = parseJwt(token || "");
  const [password, setPassword] = useState("");

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Profile</h1>
      <div className="bg-white rounded shadow-md max-w-lg">
        <div className="flex border-b">
          <Link
            to=""
            className="px-4 py-2 text-gray-500 border-b-2 border-gray-500"
          >
            Profile Details
          </Link>
          <Link
            to={`/profile/team/members`}
            className="px-4 py-2 text-gray-500 hover:text-gray-700"
          >
            Team Members
          </Link>
        </div>
        <div className="p-6">
          <div className="mb-4">
            <h2 className="text-xl font-semibold mb-4">Personal Information</h2>
            <TextInput
              value={user?.firstName ?? ""}
              label="First Name"
              required
            />
            <TextInput
              value={user?.lastName ?? ""}
              label="Last Name"
              required
            />
            <EmailInput value={user?.username ?? ""} label="Email" required />
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Password"
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
